export const ACTIVE_MARKER = 60 as const
export const ACTIVE_SEARCH_MARKER = 61 as const

export const INACTIVE_ASSET = 50 as const
export const INACTIVE_GEOFENCE = 10 as const

export const CLUSTER_MARKER = 40 as const

export const HIGH_RISK_MARKER_COLOR = '#FF0000' as const
export const GEO_FEATURE_MARKER_COLOR = '#1945B6' as const
// Lighter blue used to highlight the active LineString geofence on the map
export const ACTIVE_GEOFENCE_LINESTRING_COLOR = '#8AB7FF' as const

// Asset markers carry a white glyph, so every colour here has to stay dark enough for
// that glyph to read against it.
export const MARKER_LOST_CONTACT_COLOR = '#767676' as const
export const MARKER_LOST_CONTACT_TIMEOUT_COLOR = '#FF0000' as const

// The searched-location pin, kept at the legacy artwork's red.
export const SEARCH_MARKER_COLOR = '#D54242' as const

export const MARKER_MOVING_COLOR = '#83BE61' as const
export const MARKER_STATIONARY_COLOR = '#15A1CE' as const

export const REPLAY_MARKER_MOVING_COLOR = '#14f514' as const
export const REPLAY_MARKER_STATIONARY_COLOR = '#62d764' as const

export const getSpeedThresholdColor = (speed: number | undefined): string => {
  if (!speed) return '#B8B8B8'
  if (speed > 100) return '#EC0F00'
  if (speed > 80) return '#FE9009'
  if (speed > 60) return '#1BCA00'
  return '#4D74FF'
}

export const OBSERVATORY_MAP_VIEWPORT_PADDING_RATIO = 0.12 as const

// Task marker is always higher than geofence marker
export const TASK_MARKER = 62 as const

